<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div class="media-container">
	<nz-tabs>
		<nz-tab nzTitle="Upload Media">
			<div class="dropzone-container">
				<app-upload
					[accept]="accept"
					[multiple]="true"
					[directory]="false"
					(onCompleted)="onUploadCompleted($event)"
					title="Click or drag to upload"
					[small]="true"
				></app-upload>
			</div>
			<app-media-history-table></app-media-history-table>
		</nz-tab>
		<nz-tab nzTitle="Generate Audio">
			<app-audio-form
				(onSubmitSingle)="onSubmitSingle($event)"
				(onSubmitBatch)="onSubmitBatch($event)"
				[loadingSingle]="loadingSingle()"
				[loadingBatch]="loadingBatch()"
			></app-audio-form>
			<app-media-history-table></app-media-history-table>
		</nz-tab>
		<nz-tab nzTitle="History">
			<app-media-history-table></app-media-history-table>
		</nz-tab>
	</nz-tabs>
</div>
